import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import { ADGMTextField } from 'aurora-components';
import Box from '@material-ui/core/Box';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { numberMaskWithoutDecimalOption } from 'aurora-utils/constants';
import styles from './styles';

function FetchUser(props) {
  const { classes, formState, handleStateChange, fetchUser, isEditMode } = props;

  return (
    <div>
      <div className={classes.subPanel}>
        {formState.userType === 'person' && (
          <Box display='flex' flexDirection='column' className={classes.fetchTextField}>
            <Box>
              <ADGMTextField
                id='eidOrUnified'
                name='eidOrUnified'
                variant='outlined'
                placeholder='000-0000-000000-0'
                type='text'
                mask={createNumberMask(numberMaskWithoutDecimalOption)}
                value={formState.eidOrUnified || ''}
                onChange={handleStateChange}
                label={<FormattedMessage {...messages.UN_EID_number} />}
                required
                disabled={isEditMode}
                customClasses={{ field: classes.input }}
                autoFocus
              />
              <div className={classNames(classes.infoAlert, classes.infoAlertBorder)}>
                <svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0.181398 8.13672C0.181399 3.71844 3.76312 0.13672 8.1814 0.13672C12.5997 0.13672 16.1814 3.71844 16.1814 8.13672C16.1814 12.555 12.5997 16.1367 8.1814 16.1367C3.76312 16.1367 0.181398 12.555 0.181398 8.13672ZM8.18137 3.98857C7.69046 3.98857 7.29249 4.38654 7.29249 4.87746C7.29249 5.36838 7.69046 5.76635 8.18137 5.76635C8.67229 5.76635 9.07026 5.36838 9.07026 4.87746C9.07026 4.38654 8.67229 3.98857 8.18137 3.98857ZM9.07029 11.0997C9.07029 11.5886 8.67029 11.9886 8.1814 11.9886C7.69251 11.9886 7.29251 11.5886 7.29251 11.0997L7.29251 7.54412C7.29251 7.05523 7.69251 6.65523 8.1814 6.65523C8.67029 6.65523 9.07029 7.05523 9.07029 7.54412L9.07029 11.0997Z'
                    fill='#484456'
                  />
                </svg>

                <FormattedMessage {...messages.Enter_UN_EID_number_fetch_person_details} />
              </div>
            </Box>

            <Button
              variant='contained'
              color='secondary'
              disabled={!formState.eidOrUnified || formState.eidOrUnified?.length < 1 || isEditMode}
              onClick={fetchUser}
            >
              <FormattedMessage {...messages.fetch_details} />
            </Button>
          </Box>
        )}
      </div>
    </div>
  );
}

FetchUser.propTypes = {
  classes: PropTypes.object.isRequired,
  formState: PropTypes.object.isRequired,
  isEditMode: PropTypes.bool,
  fetchUser: PropTypes.func.isRequired,
  handleStateChange: PropTypes.func.isRequired,
};

FetchUser.defaultProps = {
  isEditMode: false,
};

export default withStyles(styles)(FetchUser);
